import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link, useParams } from 'react-router-dom';
import { vaccineGroupService } from '../../../_services/vaccine-group.service';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import queryString from 'query-string';
import WaitlistActions from "./Components/WaitlistActions";
import RemoveActions from "./Components/RemoveActions";
import moment from 'moment';

import SearchGroupComponent from "./Components/SearchGroupComponent"

export default function GroupReservations(props) {
  const columns = [
    {
      name: 'ID',
      sort: false,
      width: "80px",
      selector: 'reservationId',
      grow: 1,
    },
    {
      name: 'Status',
      sort: false,
      grow: 1,
      cell: row => {
        if (row.status === 'waitlist') {
          return <span className="badge bg-primary text-white">WAITLIST</span>
        } else if (row.status === 'pending') {
          return <span className="badge bg-info text-white">PENDING</span>
        } else if (row.status === 'scheduled') {
          return <span className="badge bg-success text-white">SCHEDULED</span>
        } else if (row.status === 'removed') {
          return <span className="badge bg-danger text-white">REMOVED</span>
        } else if (row.status === 'rejected') {
          return <span className="badge bg-warning">REJECTED</span>
        }
      }
    },
    {
      name: 'First Name',
      sort: false,
      selector: 'firstName',
      grow: 2
    },
    {
      name: 'Last Name',
      sort: false,
      selector: 'lastName',
      grow: 2
    },
    {
      name: 'Date of Birth',
      sort: false,
      selector: 'dateOfBirth',
      grow: 2
    },
    {
      name: 'Phone Number',
      sort: false,
      selector: 'phoneNumber',
      grow: 3
    },
    {
      name: 'Allow SMS',
      sort: false,
      cell: reservation => reservation.allowSms ? <span className="badge bg-success text-white">YES</span> : <span className="badge bg-warning">NO</span>,
      grow: 1
    },
    {
      button: true,
      sort: false,
      width: '200px',
      cell: row => {
        if (row.status === 'waitlist') return <WaitlistActions data={row} reload={() => retrieve()} />
        if (row.status === 'removed') return <RemoveActions data={row} reload={() => retrieve()} />
      }
    }
  ];

  const DetailComponent = ({ data }) => {
    return <div className="row">
      <div className="col-lg-4">
        <ul className="list-group list-group-flush">
          <li className="list-group-item"><strong>Reserved At:</strong> {moment.tz(data.createdAt.date, data.createdAt.timezone).local().format('l LT')}</li>
        </ul>
      </div>
    </div>
  }

  const { groupId } = useParams();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [groupName, setGroupName] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [reservations, setReservations] = useState([]);

  function retrieve(params = null) {
    vaccineGroupService.reservationsByGroup(groupId, params)
      .then(data => {
        setLoading(false);
        setTotalRows(data.total);
        setGroupName(data.groupName);
        setReservations(data.collection.data);
      })
      .catch(() => {
        setLoading(false);

        dispatch(alertActions.error('Could not load reservations. Please try again.'));
      });
  }

  function dateToYYYYMMDD(dob) {
    return dob ? dob.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2") : '';
  }

  useEffect(() => {
    retrieve();
  }, [retrieve]);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/vaccine/groups">Groups</Link></li>
        <li className="breadcrumb-item active" aria-current="page">Reservations</li>
      </ol>
    </nav>

    <DataTable
      title={groupName}
      columns={columns}
      data={reservations}
      overflowY={true}
      progressPending={loading}
      onChangePage={page => {
        setLoading(true);
        let queryParams = queryString.parse(props.location.search);
        queryParams.page = page;
        props.history.replace(`?${queryString.stringify(queryParams)}`);
        queryParams.dateOfBirth = dateToYYYYMMDD(queryParams.dateOfBirth);
        retrieve(queryParams);
      }}
      subHeader={true}
      subHeaderComponent={
        <SearchGroupComponent
          location={props.location}
          handleClear={() => { retrieve() }}
          handleSearch={(params) => {
            const { status, firstName, lastName, dateOfBirth } = params;
            props.history.replace(`?status=${status}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`);
            params.dateOfBirth = dateToYYYYMMDD(params.dateOfBirth);

            if (props.history.location.search !== props.location.search) {
              retrieve(params);
            }
          }} />
      }
      striped={true}
      pagination={true}
      paginationServer={true}
      paginationTotalRows={totalRows}
      paginationRowsPerPageOptions={[15]}
      paginationPerPage={15}
      expandableRows
      expandOnRowClicked
      expandableRowsComponent={<DetailComponent />}
      customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
    />
  </div>
}